(function (angular, location) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyApiErrorMessage", [
    "UrlParser",
    function (UrlParser) {
      var CTA_CONTEXT_PRICING_PAGE = "PricingPage";
      var CTA_CONTEXT_RANGE_PAGE = "RangePage";

      function tryAgain() {
        location.reload(true);
      }

      function tryAgainPricingPage() {
        var $pricingPage = angular.element("[data-ty-pricing-page]");
        var lastSuccessfullyLoadedMaterialCode = $pricingPage.length ? $pricingPage.scope().materialCode : null;
        var url = location.href;

        if (lastSuccessfullyLoadedMaterialCode) {
          url = UrlParser.overrideUrlQueryStringFromMap(url, {
            material_code: lastSuccessfullyLoadedMaterialCode,
          });
        }

        if (location.href === url) {
          tryAgain();
        } else {
          location.href = url;
        }
      }

      var controller = function () {
        var ctl = this;

        ctl.tryAgain = function (event) {
          if (ctl.ctaContext === CTA_CONTEXT_PRICING_PAGE) {
            tryAgainPricingPage();
            event.preventDefault();
          }

          if (ctl.ctaContext === CTA_CONTEXT_RANGE_PAGE) {
            tryAgain();
            event.preventDefault();
          }
        };
      };

      return {
        bindToController: {
          ctaContext: "@tyApiErrorMessageCtaContext",
          heading: "@tyApiErrorMessageHeading",
          subHeading: "@tyApiErrorMessageSubHeading",
        },
        restrict: "A",
        controller: controller,
        controllerAs: "tyApiErrorMessage",
      };
    },
  ]);
})(window.angular, window.location);
